import { useEffect, useRef, useState } from "react";
import { serveAds, api } from "@/lib/api";
import { Sparkles, ArrowRight } from "lucide-react";

/** Editorial hero placement for the featured advertiser of the week. */
export default function FeaturedAd() {
  const [ad, setAd] = useState(null);
  const impressed = useRef(false);

  useEffect(() => {
    serveAds("featured").then(d => {
      const list = (d.ads || []).filter(a => a.slot === "featured");
      if (list.length) setAd(list[0]);
    }).catch(()=>{});
  }, []);

  useEffect(() => {
    if (ad && !impressed.current) { impressed.current = true; api.post(`/ads/${ad.id}/impression`).catch(()=>{}); }
  }, [ad]);
  if (!ad) return null;
  const onClick = () => api.post(`/ads/${ad.id}/click`).catch(()=>{});

  return (
    <section className="mb-12" data-testid="featured-advertiser-section">
      <div className="flex items-center gap-2 mb-4">
        <Sparkles className="w-4 h-4 text-[#D4AF37]" />
        <span className="text-[11px] font-semibold tracking-[0.25em] uppercase text-[#D4AF37]">Featured Advertiser of the Week</span>
      </div>
      <a href={ad.click_url} onClick={onClick} target="_blank" rel="noopener noreferrer" className="grid md:grid-cols-[1.2fr_1fr] gap-6 items-stretch bg-gradient-to-r from-[#0A0A0E] via-[#0E0E14] to-[#0A0A0E] border border-[#D4AF37]/30 rounded-2xl overflow-hidden shadow-[0_10px_50px_rgba(212,175,55,0.10)] group" data-testid={`ad-slot-featured`}>
        <div className="aspect-[16/10] md:aspect-auto overflow-hidden bg-black">
          <img src={ad.image_url} alt={ad.title} className="w-full h-full object-cover group-hover:scale-105" style={{transition:"transform 0.6s"}} />
        </div>
        <div className="p-8 flex flex-col justify-center">
          <p className="text-[10px] tracking-widest uppercase text-[#D4AF37] mb-3">Sponsored · Featured Placement</p>
          <h3 className="font-heading text-3xl md:text-4xl font-bold text-white leading-tight mb-4">{ad.title}</h3>
          {ad.editorial_text && <p className="text-white/70 leading-relaxed mb-5 line-clamp-5">{ad.editorial_text}</p>}
          <div className="inline-flex items-center gap-2 text-[#D4AF37] font-semibold text-sm">Learn more <ArrowRight className="w-4 h-4 group-hover:translate-x-1" style={{transition:"transform 0.3s"}} /></div>
        </div>
      </a>
    </section>
  );
}
